import { useTranslation } from 'react-i18next'

import { Status } from '../../Status'
import { getCalendarItemStatusProps } from '../Calendar.utils'

function CalendarItemStatus({ className, item }) {
  const { t } = useTranslation()

  const statusProps = getCalendarItemStatusProps(item)

  return statusProps ? (
    <Status {...statusProps} className={className} text={t(statusProps.text)} />
  ) : null
}

export default CalendarItemStatus
